import { URLS } from '@/config'
import { CommonUrls } from '@/dashboards/common'
const SHELL_CONFIG_URL = process.env.VUE_APP_SHELL_CONFIG_URL || `${CommonUrls.GATEWAY_BASE_URL}auth/user/v1/shell-config?dashboard=crm-farmapremium`
const SETTINGS_CONFIG_URL = process.env.VUE_APP_SETTINGS_CONFIG_LOCAL_URL || `${CommonUrls.PUBLIC_STORAGE}/applications/crm-shell-config/settings-config.json`
const CRM_BASE_URL = `https://crm${URLS.URL_ENV_CODE}.farmapremium.es`

const LOGOUT_URL = CommonUrls.APPS_LOGOUT_URL
const LOGIN_URL = CommonUrls.APPS_LOGIN_URL
const REFRESH_TOKEN_URL = CommonUrls.CRM_REFRESH_TOKEN_URL

export default {
  ...CommonUrls,
  LOGOUT_URL,
  LOGIN_URL,
  SHELL_CONFIG_URL,
  SETTINGS_CONFIG_URL,
  CRM_BASE_URL,
  REFRESH_TOKEN_URL
}
